import { VolunteerCompanyRegistration } from 'src/assets/styles/components/network';

const NetworkFormLayout = ({ className, title, subtitle, children }) => (
  <VolunteerCompanyRegistration className={className || ''} id="company">
    <div className="inner">
      <header>
        <h2>{title}</h2>
        {subtitle ? <p className="header-subtitle">{subtitle}</p> : null}
      </header>
      {children}
    </div>
  </VolunteerCompanyRegistration>
);

export default NetworkFormLayout;
